import type { AxiosError } from "axios";
import { createAsyncAction } from "typesafe-actions";

import type {
  CreateDataObjectResponse,
  CreateJobResponse,
  GetIdentityResponse,
  GetJobsResponse,
  RetryJobResponse,
} from "../../types/responses";

export const actions = {
  getMe: createAsyncAction(
    "api/GET_ME_REQUEST",
    "api/GET_ME_SUCCESS",
    "api/GET_ME_FAILURE",
  )<void, GetIdentityResponse, AxiosError>(),
  getJobs: createAsyncAction(
    "api/GET_JOBS_REQUEST",
    "api/GET_JOBS_SUCCESS",
    "api/GET_JOBS_FAILURE",
  )<void, GetJobsResponse, AxiosError>(),
  createJob: createAsyncAction(
    "api/CREATE_JOB_REQUEST",
    "api/CREATE_JOB_SUCCESS",
    "api/CREATE_JOB_FAILURE",
  )<void, CreateJobResponse, AxiosError>(),
  retryJob: createAsyncAction(
    "api/RETRY_JOB_REQUEST",
    "api/RETRY_JOBS_SUCCESS",
    "api/RETRY_JOBS_FAILURE",
  )<void, RetryJobResponse, AxiosError>(),
  createDataObject: createAsyncAction(
    "api/CREATE_DATA_OBJECTS_REQUEST",
    "api/CREATE_DATA_OBJECTS_SUCCESS",
    "api/CREATE_DATA_OBJECTS_FAILURE",
  )<void, CreateDataObjectResponse, AxiosError>(),
};
